import BrushOutlinedIcon from "@mui/icons-material/BrushOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import HexagonOutlinedIcon from "@mui/icons-material/HexagonOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";

const ICON_MAP = {
  brush: BrushOutlinedIcon,
  share: ShareOutlinedIcon,
  brand: AutoAwesomeOutlinedIcon,
  logo: HexagonOutlinedIcon,
  package: Inventory2OutlinedIcon,
  print: PrintOutlinedIcon,
  web: LanguageOutlinedIcon,
  campaign: CampaignOutlinedIcon,
  video: VideocamOutlinedIcon,
  product: ShoppingBagOutlinedIcon,
  palette: PaletteOutlinedIcon,
  trending: TrendingUpOutlinedIcon,
  teams: GroupsOutlinedIcon,
  rocket: RocketLaunchOutlinedIcon,
};

export default function ServiceIcon({ name, className = "", size = "medium" }) {
  const Icon = ICON_MAP[name] || PaletteOutlinedIcon;
  const sizeClass =
    size === "large" ? "text-[28px]" : size === "small" ? "text-[18px]" : "text-[22px]";

  return (
    <span
      className={`inline-flex items-center justify-center text-accent-light ${sizeClass} ${className}`}
      aria-hidden
    >
      <Icon fontSize="inherit" />
    </span>
  );
}
